const state = {
    current_app_content: {}
}

const mutations = {
    setCurrentAppContent(state, obj) {
        state.current_app_content = obj
    }
}

const actions = {
    setCurrentAppContent({ commit }, obj) {
        commit('setCurrentAppContent', obj)
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/siemens.js